import { forwardLog } from "utils/logForwarder";

let currentTraceId = null;

export function setTraceId(traceId) {
	currentTraceId = traceId;
}

export function getTraceId() {
	return currentTraceId;
}

export function traceLog(message) {
	const prefix = currentTraceId ? `[X-Trace-Id: ${currentTraceId}]` : "[X-Trace-Id: N/A]";
	const fullMessage = `${prefix} ${message}`;
	// eslint-disable-next-line no-console
	console.log(fullMessage);
	forwardLog({ level: "info", message: fullMessage, "x-trace-id": currentTraceId });
}

export function traceError(message, error) {
	const prefix = currentTraceId ? `[X-Trace-Id: ${currentTraceId}]` : "[X-Trace-Id: N/A]";
	const errorDetail = error?.message || error || "";
	const fullMessage = `${prefix} ${message} ${errorDetail}`.trim();
	// eslint-disable-next-line no-console
	console.error(fullMessage);
	forwardLog({ level: "error", message: fullMessage, "x-trace-id": currentTraceId });
}
